import { render, staticRenderFns } from "./STEP2.vue?vue&type=template&id=03b0daa4&scoped=true&"
import script from "./STEP2.vue?vue&type=script&lang=js&"
export * from "./STEP2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0daa4",
  null
  
)

export default component.exports